export default __webpack_public_path__ + "static/media/miguel-lopes-19.c9090fe5.jpg";